import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Calendar, Mail, Star } from 'lucide-react';

const AccountDetails = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
            <Card className="p-6">
              <h1 className="text-2xl font-bold mb-6">Datos de la Cuenta</h1>
              
              <div className="space-y-6">
                {/* Account Status */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Estado de la cuenta</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Card className="p-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-gray-600">Tipo de cuenta</span>
                        <Badge>
                          {user?.role === 'buyer' && 'Comprador'}
                          {user?.role === 'seller' && 'Vendedor'}
                          {user?.role === 'advertiser' && 'Anunciante'}
                        </Badge>
                      </div>
                    </Card>
                    
                    <Card className="p-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-gray-600">Reputación</span>
                        <div className="flex items-center">
                          <Star className="w-4 h-4 fill-yellow-400 text-yellow-400 mr-1" />
                          <span className="font-semibold">{user?.reputation || 5.0}</span>
                        </div>
                      </div>
                    </Card>

                    <Card className="p-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-gray-600">Email verificado</span>
                        <Badge variant="outline" className="bg-green-50 text-green-700">
                          Verificado
                        </Badge>
                      </div>
                    </Card>
                  </div>
                </div>

                {/* Activity Stats */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Actividad</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Card className="p-4">
                      <div className="text-3xl font-bold text-zl-orange mb-2">
                        {user?.purchases || 0}
                      </div>
                      <div className="text-gray-600">Compras realizadas</div>
                    </Card>

                    {user?.role !== 'buyer' && (
                      <Card className="p-4">
                        <div className="text-3xl font-bold text-green-600 mb-2">
                          {user?.sales || 0}
                        </div>
                        <div className="text-gray-600">Ventas completadas</div>
                      </Card>
                    )}
                  </div>
                </div>

                {/* Account Info */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Información de la cuenta</h3>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3 text-gray-700">
                      <Mail className="w-5 h-5 text-gray-400" />
                      <div>
                        <div className="text-sm text-gray-500">Email</div>
                        <div className="font-medium">{user?.email}</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-3 text-gray-700">
                      <Calendar className="w-5 h-5 text-gray-400" />
                      <div>
                        <div className="text-sm text-gray-500">Miembro desde</div>
                        <div className="font-medium">
                          {user?.created_at 
                            ? new Date(user.created_at).toLocaleDateString('es-AR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                            : 'Fecha no disponible'
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
    </div>
  );
};

export default AccountDetails;
